function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:none;stroke:#00063c;stroke-linecap:round;stroke-linejoin:round;stroke-width:.75px}\n        "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_29",
  "data-name": "Group 29",
  transform: "translate(-171.068 -288.748)"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_28",
  "data-name": "Group 28"
}, /*#__PURE__*/React.createElement("g", {
  id: "prefix__Group_27",
  "data-name": "Group 27",
  transform: "translate(171.514 293.826)"
}, /*#__PURE__*/React.createElement("path", {
  id: "prefix__Line_10",
  d: "M0 0L16.069 0.001",
  className: "prefix__cls-1",
  "data-name": "Line 10"
}))), /*#__PURE__*/React.createElement("path", {
  id: "prefix__Path_23",
  d: "M176.014 289.279l-4.57 4.569 4.55 4.55",
  className: "prefix__cls-1",
  "data-name": "Path 23"
}));

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.889,
    height: 10.18,
    viewBox: "0 0 16.889 10.18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowLeft.520ef119.svg";
export { ForwardRef as ReactComponent };